export function dataEhPosterior(data1: string, data2: string): boolean {
  const [d1, m1, a1] = data1.split("/");
  const [d2, m2, a2] = data2.split("/");
  const date1 = new Date(`${a1}-${m1}-${d1}`);
  const date2 = new Date(`${a2}-${m2}-${d2}`);
  return date2 > date1;
}
